import CustomPalette from '@/theme/CustomPalette'
import { SxProps, Theme } from '@mui/material'

export const paginationContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mt: 2,
}

export const rowsPerPageSelect: SxProps<Theme> = {
  mx: 2,
  height: '32px',
  minWidth: 60,
  '&.MuiInputBase-root, &.MuiOutlinedInput-root, &.MuiInputBase-colorPrimary, &.MuiSelect-root': {
    border: 'none',
    borderRadius: 0,
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
      borderRadius: '10px',
    },
  },
}

export const paginationItem: SxProps<Theme> = {
  '&.MuiPaginationItem-root': {
    borderRadius: '50%',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '&.Mui-selected': {
    backgroundColor: CustomPalette.PilotBlue,
    color: CustomPalette.white,
    '&:hover': {
      backgroundColor: CustomPalette.PilotBlue,
    },
  },
}

export const paginationButton: SxProps<Theme> = {
  '&.MuiPaginationItem-root': {
    backgroundColor: CustomPalette.PilotBlueShadow,
    color: CustomPalette.NightBlue200,
    border: 'none',
    padding: '8px 16px',
    margin: '0 4px',
    borderRadius: '20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: CustomPalette.PilotBlueShadow,
    },
  },
}
